import React, { FC, useEffect, useState } from 'react';
import { NormalGroup, StrongGroup, WeakGroup, LittleWormChartCont } from './LittleWormChart.styles';
import { BodyBoldM } from '../../styles/globals';

interface ILittleWormChart {
  weakValue: number;
  normalValue: number;
  strongValue: number;
  size?: 'tiny' | 'small' | 'normal';
}

const LittleWormChart: FC<ILittleWormChart> = ({
  weakValue,
  normalValue,
  strongValue,
  size = 'normal',
}) => {
  const [percentages, setPercentages] = useState({ weak: 0, normal: 0, strong: 0 });
  const countPercentage = (sum: number, value: number) => (value / sum) * 100;

  useEffect(() => {
    const sum = weakValue + normalValue + strongValue;
    setPercentages({
      weak: countPercentage(sum, weakValue),
      normal: countPercentage(sum, normalValue),
      strong: countPercentage(sum, strongValue),
    });
  }, [normalValue, strongValue, weakValue]);

  return (
    <LittleWormChartCont data-testid="littleWormChart">
      {weakValue > 0 && (
        <WeakGroup size={size} width={percentages.weak}>
          {weakValue}
        </WeakGroup>
      )}
      {normalValue > 0 && (
        <NormalGroup size={size} width={percentages.normal}>
          {normalValue}
        </NormalGroup>
      )}
      {strongValue > 0 && (
        <StrongGroup size={size} width={percentages.strong}>
          {strongValue}
        </StrongGroup>
      )}
    </LittleWormChartCont>
  );
};

export default LittleWormChart;
